import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map,switchMap, withLatestFrom } from "rxjs/operators";

import { MpAdminService } from "../../../services/api/mp-admin.service";
import { MpAdminActions } from "../../actions/mp-admin.actions";
import { FailState } from "../../models/fail-state";
import { ConsumerProposalsState } from "../../models/mp-admin/consumer-proposals-state";
import { AppState } from "../../reducers";
import { MpAdminSelectors } from "../../selectors/mp-admin.selectors";

@Injectable()
export class ConsumerBalancesEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.consumerBalances.get),
			withLatestFrom(this.store.select(MpAdminSelectors.consumerBalances)),
			switchMap(([action, state]) =>
				this.canUseStoreValue(action, state)
					? of(MpAdminActions.consumerBalances.getSuccess(state))
					: of(MpAdminActions.consumerBalances.getApi())
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.consumerBalances.getApi),
			switchMap(() =>
				this.adminService.consumerBalances().pipe(
					map((consumerBalances) =>
						MpAdminActions.consumerBalances.getSuccess({
							consumerBalances,
							loading: false
						})
					),
					catchError((error) =>
						of(MpAdminActions.consumerBalances.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private store: Store<AppState>,
		private actions: Actions,
		private adminService: MpAdminService
	) {}

	private canUseStoreValue(action, state: ConsumerProposalsState): boolean {
		return !_.has(state, "error") && !state.loading;
	}
}
